<template>
  <div id="app">
    <div>
      <Home />
      <!-- <AddModule /> -->
      <!-- <districtIndex/> -->
      <!-- <router-view /> -->

    </div>
  </div>
</template>

<script>
import Home from "./views/Home";
// import AddModule from "./views/AddModule";
// import districtIndex from "./views/question/district";
export default {
  name: "App",
  components: {
    Home
    // AddModule,
    // districtIndex
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "SH-Regular";
  /* src: url("./assets/fonts/SourceHanSansSC-Bold.otf") format("opentype"); */
  /* src: url("./assets/fonts/SourceHanSansSC-Light.otf") format("opentype"); */
  /* src: url("./assets/fonts/SourceHanSansSC-Medium.otf") format("opentype"); */
  src: url("./assets/fonts/SourceHanSansSC-Regular.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family: SH-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  min-width: 1300px;

  /* width: 100%; */
  height: 100%;
  background: #ccc;
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
}

body,
html {
  width: 100%;
  height: 100%;
  margin: 0;
  font-size: 14rem;
  min-width: 1300px;
}
ul,
ul li,
p {
  list-style: none; /* 去除列表项前的标记 */
  padding: 0; /* 去除列表项的内边距 */
  margin: 0; /* 去除列表项的外边距 */
}

.addressFilter .el-button,
.testContent .el-button {
  background-image: var(--background-image);
  // border-color: var(--primary-color);
  border-color: rgba(0, 0, 0, 0) !important;
  border-radius: 6rem;
  height: 32rem;
  padding: 8rem 15rem
}
</style>
